import Container from "../components/Container";
import VerticalDisplayImage from "../components/Images/VerticalDisplayImage";
import Fancybox from "../components/FancyBox";
import React from "react";

const AboutTheAssociationOrganizationalStructure = () => {

  React.useEffect(() => {
    Fancybox.bind("[data-fancybox='images']");
  }, []);

  const imagesData = [
    {
      url: "/images/organizational-structure/Screenshot 2024-12-23 at 5.46.59 PM.png",
      alt: "Organizational Structure",
      filename: "Screenshot 2024-12-23 at 5.46.59 PM.png",
    },
  ];

  return (
    <>
      <div>
        <h1 className="text-white font-bold text-center bg-primary py-8">الهيكل التنظيمي</h1>
      </div>
      <Container>
        <Fancybox
          options={{
            Carousel: {
              infinite: true,
            },
          }}
        >
          {imagesData.map((image, index) => {
            const { url, alt, filename } = image;
            return (
              <a key={index} data-fancybox="gallery" href={url}>
                <VerticalDisplayImage
                  key={filename}
                  url={url}
                  alt={alt}
                  filename={filename}
                />
              </a>
            );
          })}
        </Fancybox>
      </Container>
    </>
  )
}

export default AboutTheAssociationOrganizationalStructure